export const LoadingOverlay = {
    show: () => {
        const loader = document.getElementById('global-loader');
        if (!loader) return;
        
        loader.classList.remove('hidden');
    },
    
    hide: async () => {
        const loader = document.getElementById('global-loader');
        if (!loader) return;
        
        loader.classList.add('hidden');
        await new Promise(resolve => setTimeout(resolve, 200));
    }
};

const rawAssets = import.meta.glob('@assets/**/*', { eager: true, import: 'default' });

/**
 * Перетворює шлях з аліасом @assets у реальний URL після збірки
 */
export const resolveAsset = (pathWithAlias: string): string => {
    const fullPath = pathWithAlias.replace('@assets', '/src/assets');
    const resolved = rawAssets[fullPath];
    
    if (!resolved) {
        console.warn(`Asset not found: ${fullPath}`);
        return pathWithAlias; // Фолбек
    }
    
    return resolved as string;
};